import { ReactNode } from 'react';
import { Link } from 'react-router';

import { Box, Button, Flex } from '@valwin/facto/components';

type AccessDeniedProps = {
  title: string;
  message: ReactNode;
  icon: ReactNode;
  link: string;
};

export function AccessDenied({
  title,
  message,
  icon,
  link,
}: AccessDeniedProps) {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      gap="4"
      minHeight="vh"
    >
      <Box textAlign="center">
        {icon}
        <Box fontSize="lg">{title}</Box>
        <Box fontSize="sm">{message}</Box>
      </Box>

      <Button>
        <Link to={link}>Retour</Link>
      </Button>
    </Flex>
  );
}
